import { render, staticRenderFns } from "./ClassroomDetailTabMyTasksLibrary.vue?vue&type=template&id=507f4668&scoped=true"
import script from "./ClassroomDetailTabMyTasksLibrary.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyTasksLibrary.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMyTasksLibrary.vue?vue&type=style&index=0&id=507f4668&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f4668",
  null
  
)

export default component.exports